import {
  ALL_BRANDS_URL_ID,
  EXCLUSIVES_CATEGORY_URL_ID,
  NEW_ARRIVALS_SUBCATEGORY_URL_ID,
  NEW_BRANDS_CATEGORY_URL_ID,
  NEW_PRODUCTS_CATEGORY_URL_ID,
  TOP_SELLERS_CATEGORY_URL_ID,
} from "@faire/retailer-shared/categories/urlId";
import { StrictLocalizeFunction } from "@faire/web/common/localization/localize";

export const COOK_AT_HOME_URL_ID = "Cook at Home";
export const FAMILY_TIME_URL_ID = "Family Time";
export const SELF_CARE_URL_ID = "Self Care";
export const WORK_FROM_HOME_URL_ID = "Work from Home";
export const COZY_APPAREL_URL_ID = "Cozy Apparel";
export const ECO_CONSCIOUS_URL_ID = "For the Eco Conscious";
export const FREE_RETURN_URL_ID = "eligible_for_free_returns";

export const BASED_IN_EUROPE_URL_ID = "Based in Europe";

export const getCategoryDisplayName = (
  categoryName: string,
  strictLocalize: StrictLocalizeFunction
): string => {
  switch (categoryName) {
    case NEW_ARRIVALS_SUBCATEGORY_URL_ID:
    case NEW_BRANDS_CATEGORY_URL_ID:
      return strictLocalize({
        id: "osJFqG",
        defaultMessage: "New Brands",
        description: { text: "Category of new brands on Faire" },
      });
    case ALL_BRANDS_URL_ID:
      return strictLocalize({
        id: "EvM0Kh",
        defaultMessage: "All Brands",
        description: { text: "Category listing all brands on Faire" },
      });
    case NEW_PRODUCTS_CATEGORY_URL_ID:
      return strictLocalize({
        id: "JqMZ/6",
        defaultMessage: "New Products",
        description: { text: "Category of new products on Faire" },
      });
    case TOP_SELLERS_CATEGORY_URL_ID:
      return strictLocalize({
        id: "wdxc+X",
        defaultMessage: "Best Sellers",
        description: {
          text: "Category with brands that are popular in the platform",
        },
      });
    case EXCLUSIVES_CATEGORY_URL_ID:
      return strictLocalize({
        id: "fhH27D",
        defaultMessage: "Insider Early Access",
        description: { text: "Early product access for insiders" },
      });
    case BASED_IN_EUROPE_URL_ID:
      return strictLocalize({
        id: "S4rv9u",
        defaultMessage: "Based in Europe",
        description: {
          text: "Title of page that shows wholesalers that are based in europe",
          img: "https://cdn.faire.com/fastly/4150e9a49719d71bb782badb00ef2f5167346aec61d3b857fe77ae1a93e62c76.png",
        },
      });
    default:
      return categoryName;
  }
};

const NEW_CATEGORIES = [
  NEW_BRANDS_CATEGORY_URL_ID,
  NEW_PRODUCTS_CATEGORY_URL_ID,
];

export const isNewCategory = (categoryUrlId: string | undefined): boolean =>
  !categoryUrlId ? false : NEW_CATEGORIES.includes(categoryUrlId);
